(ns core.front.carbon-icons
  "Centralized registry of Carbon Design System icons keyed by :icon/* keywords."
  (:require ["@carbon/icons-react/es/bullhorn/24" :default Bullhorn24]
            ["@carbon/icons-react/es/calendar/24" :default Calendar24]
            ["@carbon/icons-react/es/document/24" :default Document24]
            ["@carbon/icons-react/es/information/24" :default Information24]
            ["@carbon/icons-react/es/location/24" :default Location24]
            ["@carbon/icons-react/es/notification/24" :default Notification24]
            ["@carbon/icons-react/es/phone/24" :default Phone24]
            ["@carbon/icons-react/es/time/24" :default Time24]))


(def icons
  "Map of :icon/* keyword to Carbon React icon component."
  {:icon/clock     Time24
   :icon/calendar  Calendar24
   :icon/location  Location24
   :icon/info      Information24
   :icon/bell      Notification24
   :icon/phone     Phone24
   :icon/document  Document24
   :icon/megaphone Bullhorn24})
